import femaleV2Image from 'assets/images/gender-female-2248-image.png'
import femaleV3Image from 'assets/images/gender-female-V3-image.png'
import maleV2Image from 'assets/images/gender-male-2248-image.png'
import maleV3Image from 'assets/images/gender-male-V3-image.png'
import maleV7Image from 'assets/images/men-healing-image.png'
import femaleV7Image from 'assets/images/women-healing-image.png'

import { Cohort, Gender, PageVersions } from 'root-constants'

import { TGenderOption } from '../types'
import {
  TContentConfig,
  TGenderOptionsByVersion,
  TVersionByCohort,
} from './types'

export const VERSION_BY_COHORT = {
  [Cohort.FLOW_1_INTRO_LONG_2248]: PageVersions.V1,
  [Cohort.FLOW_AYAH_313]: PageVersions.V2,
  [Cohort.FLOW_AYAH_313_AM]: PageVersions.V2,
  [Cohort.AP_QURAN_313_C]: PageVersions.V2,
  [Cohort.AP_QURAN_313_CF]: PageVersions.V2,
  [Cohort.AP_QURAN_313_C_AM]: PageVersions.V2,
  [Cohort.AP_QURAN_313_CC]: PageVersions.V2,
  [Cohort.AP_QURAN_313_CT]: PageVersions.V2,
  [Cohort.AP_QURAN_410]: PageVersions.V2,
  [Cohort.AP_QURAN_610]: PageVersions.V2,
  [Cohort.AP_QURAN_337]: PageVersions.V2,
  [Cohort.AP_QURAN_326]: PageVersions.V2,
  [Cohort.FLOW_AYAH_314]: PageVersions.V2,
  [Cohort.FLOW_AYAH_314_C]: PageVersions.V2,
  [Cohort.FLOW_1_INTRO_LONG_2466]: PageVersions.V3,
  [Cohort.FLOW_1_INTRO_LONG_2469]: PageVersions.V3,
  [Cohort.FLOW_1_INTRO_LONG_2261]: PageVersions.V5,
  [Cohort.FLOW_1_INTRO_LONG_3350]: PageVersions.V6,
  [Cohort.FLOW_1_INTRO_LONG_2271]: PageVersions.V4,
  [Cohort.FLOW_1_INTRO_LONG_2271_C]: PageVersions.V4,
  [Cohort.BP_HEALING_2433]: PageVersions.V7,
  default: PageVersions.V4,
} as const satisfies TVersionByCohort

const DEFAULT_GENDER_OPTIONS = [
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.female',
    imageUrl: femaleV2Image,
  },
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.male',
    imageUrl: maleV2Image,
  },
] as const satisfies readonly TGenderOption[]

const GENDER_OPTIONS_V4 = [
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.woman',
    imageUrl: femaleV3Image,
  },
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.man',
    imageUrl: maleV3Image,
  },
] as const satisfies readonly TGenderOption[]

const AYAH_GENDER_OPTIONS = [
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.woman',
    imageUrl: femaleV3Image,
  },
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.man',
    imageUrl: maleV3Image,
  },
] as const satisfies readonly TGenderOption[]

export const GENDER_OPTIONS_MAP = {
  [PageVersions.V1]: DEFAULT_GENDER_OPTIONS,
  [PageVersions.V2]: AYAH_GENDER_OPTIONS,
  [PageVersions.V3]: [
    {
      value: Gender.FEMALE,
      text: 'commonComponents.gender.female',
      imageUrl: femaleV3Image,
    },
    {
      value: Gender.MALE,
      text: 'commonComponents.gender.male',
      imageUrl: maleV3Image,
    },
  ],
  [PageVersions.V4]: GENDER_OPTIONS_V4,
  [PageVersions.V5]: GENDER_OPTIONS_V4,
  [PageVersions.V6]: GENDER_OPTIONS_V4,
  [PageVersions.V7]: [
    {
      value: Gender.FEMALE,
      text: 'commonComponents.gender.female',
      imageUrl: femaleV7Image,
    },
    {
      value: Gender.MALE,
      text: 'commonComponents.gender.male',
      imageUrl: maleV7Image,
    },
  ],
} as const satisfies TGenderOptionsByVersion

export const CONTENT_CONFIG = {
  [PageVersions.V1]: {
    showSubtitle: false,
    showTopic: true,
    isLargeTitle: false,
  },
  [PageVersions.V3]: {
    showSubtitle: true,
    showTopic: true,
    isLargeTitle: false,
  },
  [PageVersions.V4]: {
    showSubtitle: false,
    showTopic: true,
    isLargeTitle: true,
  },
  [PageVersions.V5]: {
    showSubtitle: false,
    showTopic: true,
    isLargeTitle: true,
  },
  [PageVersions.V6]: {
    showSubtitle: false,
    showTopic: false,
    isLargeTitle: false,
  },
  [PageVersions.V7]: {
    showSubtitle: false,
    showTopic: true,
    isLargeTitle: false,
  },
} as const satisfies TContentConfig
